module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_redefine.js
// module id = 89
// module chunks = 1 2 3